<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <b-button to="/settings" variant="outline" class="text-primary">
            <feather-icon icon="ArrowLeftIcon" /> Back to Settings
          </b-button>
          <div>
            <h3 class="font-weight-bolder mb-0">
              Customer Profiles and Betting Templates
            </h3>
            <p class="text-muted mb-0">
              Configure betting limits and templates for NEW template
            </p>
          </div>
        </div>
        <div>
          <b-button variant="outline-primary" class="mr-1 font-weight-bolder">
            <feather-icon icon="FileTextIcon" /> Manage Templates
          </b-button>
          <b-button variant="primary">
            <feather-icon icon="PlusIcon" /> Add Profile</b-button
          >
        </div>
      </div>
    </b-col>

    <b-col cols="12" class="mt-2">
      <b-row>
        <b-col md="3" v-for="(stat, index) in stats" :key="index">
          <b-card class="">
            <p class="text-muted font-weight-bold">{{ stat.label }}</p>
            <h3
              v-if="Number(stat.value)"
              class="mb-0 font-weight-bolder"
              :class="stat.color"
            >
              {{ stat.value }}
            </h3>
            <b-badge v-else variant="primary">{{ stat.value }}</b-badge>
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <b-row>
        <b-col cols="12"> <h5>Betting Templates</h5></b-col>
        <b-col cols="12">
          <div class="d-flex flex-wrap" style="gap: 12px">
            <div
              v-for="(template, index) in profiles"
              :key="index"
              class="template-badge d-flex align-items-center justify-content-between cursor-pointer"
              :style="{ backgroundColor: getColorFromProfileName(template) }"
              @click="setActiveProfile(template)"
            >
              <span class="font-weight-bold text-white text-nowrap">{{
                template
              }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- SYSTEM ACCEPT BETS toggle -->
    <b-col cols="12" class="mt-2">
      <SystemAcceptBets />
    </b-col>

    <b-col cols="12" class="mt-2">
      <b-tabs pills active-nav-item-class="active">
        <b-tab title="Racing" active>
          <template #title>
            <strong>Racing </strong>
          </template>
          <TableRacing />
        </b-tab>
        <b-tab title="Sports">
          <template #title>
            <strong>Sports </strong>
          </template>
          <TableSport />
        </b-tab>
      </b-tabs>
    </b-col>

    <b-col cols="12" class="mt-2">
     <MultiFixedLimits />
    </b-col>

    <b-col cols="12" class="mt-2">
      <ProfileCard
        :summary="profileSummary"
        @create-template="onCreateTemplate"
        @edit-template="onEditTemplate"
        @view-all="onViewAll"
        @delete-template="onDeleteTemplate"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BCol,
  BRow,
  BButton,
  BIcon,
  BDropdown,
  BBadge,
  BDropdownItem,
  BTabs,
  BTable,
  BFormInput,
  BFormSelect,
  BTab,
} from "bootstrap-vue";
import TableSport from "./TableSport.vue";
import TableRacing from "./TableRacing/index.vue";
import { mapActions } from "vuex";
import MultiFixedLimits from "./MultiFixedLimits.vue";
import ProfileCard from "./ProfileCard.vue";
import SystemAcceptBets from "./SystemAcceptBets.vue";

export default {
  components: {
    BCard,
    BCol,
    BRow,
    BButton,
    BIcon,
    BDropdown,
    BBadge,
    BDropdownItem,
    BTabs,
    BTable,
    BFormInput,
    BFormSelect,
    TableSport,
    TableRacing,
    BTab,
    MultiFixedLimits,
    ProfileCard,
    SystemAcceptBets,
  },

  data() {
    return {
      stats: [
        { label: "Active Templates", value: 8, color: "text-body" },
        { label: "Racing Bet Types", value: 12, color: "text-primary" },
        { label: "Sports Bet Types", value: 9, color: "text-success" },
        { label: "Selected Template", value: "NEW", color: "text-body" },
      ],
      profiles: [],
      profileSummary: {
        customers: 234,
        templates: 18,
        activePercent: 76,
        racing: 11,
        sports: 7,
      },
    };
  },
  computed: {},
  async created() {
    await this.fetchProfileList();
  },
  methods: {
    ...mapActions({
      getProfileList: "user/list/getProfileList",
      setActiveProfile: "bettingConfig/list/setActiveProfile",
    }),
    async fetchProfileList() {
      const data = await this.getProfileList();
      this.profiles = data.map((i) => i.profileTypeId);
      this.setActiveProfile(this.profiles[0]);
    },
    onCreateTemplate(profile) {
      console.log("Create Template for:", profile);
    },
    onEditTemplate(profile) {
      console.log("Edit Template for:", profile);
    },
    onViewAll(profile) {
      this.$router.push({ name: "settings-betting-template-list", query: { profile } });
    },
    onDeleteTemplate(profile) {
      console.log("Delete Template for:", profile);
    },
    getColorFromProfileName(name) {
      const colorList = [
        "#5A6A7A",
        "#F48FB1",
        "#8BC34A",
        "#F44336",
        "#FFEB3B",
        "#FF9800",
        "#03A9F4",
        "#4CAF50",
      ];
      if (!name || colorList.length === 0) {
        return "#CCCCCC";
      }
      let hash = 0;
      const cleanName = name.toLowerCase();

      for (let i = 0; i < cleanName.length; i++) {
        hash += cleanName.charCodeAt(i);
      }
      const colorIndex = hash % colorList.length;

      return colorList[colorIndex];
    },
  },
};
</script>

<style lang="scss" scoped>
.template-badge {
  border-radius: 12px;
  padding: 6px 12px;
  margin: 4px;
  position: relative;
  min-width: 120px;
}

.count-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 0.75rem;
}

.cards-row {
  gap: 1rem;
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
}
.data-row {
  gap: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.card-sm {
  border-radius: 0.5rem;
}
.input-fixed {
  width: 100%;
}
.select-fixed {
  width: 100%;
}
.table-row-hover:hover {
  background-color: #f8fafc;
}
</style>
